function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  "data-name": "f2392303-e102-4e6b-880a-7b7407cb9a60",
  d: "M132.7 12.76a56.52 56.52 0 01-15.6 4.3 27.69 27.69 0 0012-15.1 53.47 53.47 0 01-17.3 6.6 27.27 27.27 0 00-46.4 24.9A77.34 77.34 0 019.2 4.96a27.31 27.31 0 008.5 36.4 26.39 26.39 0 01-12.3-3.4v.3a27.2 27.2 0 0021.8 26.7 28.36 28.36 0 01-12.3.5 27.25 27.25 0 0025.4 18.9A55 55 0 010 95.56a77.25 77.25 0 0041.7 12.3c50.1 0 77.5-41.5 77.5-77.5 0-1.2 0-2.4-.1-3.5a52.14 52.14 0 0013.6-14.1z"
});

var SvgSocialTwitter = function SvgSocialTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "0d143549-3c52-40eb-90b0-3dde9d0b1e23",
    viewBox: "0 0 132.7 107.86",
    "aria-hidden": true
  }, props), _ref);
};

export default SvgSocialTwitter;